import React from 'react';
import ContainerBox from 'components/ContainerBox';

import { Typography, Grid, Box } from '@mui/material';
import ImportUpload from './components/ImportUpload';
import ImportInstructions from './components/ImportInstructions';
import LearnMore from 'components/LearnMore';

interface Props {
	loading: boolean;
	error: string | null;
	onCsvUpload: (file: File) => void;
}
const StartImport = (props: Props) => {
	const { loading, error, onCsvUpload } = props;

	return (
		<Grid container spacing={2}>
			<Grid item xs={12} md={6}>
				<ContainerBox>
					<ImportInstructions />
				</ContainerBox>
				<Box mt={4}>
					<LearnMore
						linkHref="https://support.rentle.io/en/inventory-import"
						labelVariant="inventoryImport"
					/>
				</Box>
			</Grid>
			<Grid item xs={12} md={6}>
				<ContainerBox>
					<>
						<ImportUpload loading={loading} onUpload={onCsvUpload} />
						{!!error && (
							<Typography variant="body2" color="error" sx={{ mt: 2 }}>
								{error}
							</Typography>
						)}
					</>
				</ContainerBox>
			</Grid>
		</Grid>
	);
};

export default StartImport;
